import { Link } from "react-router-dom";
import React, { useState, useMemo } from "react";
import AgGridTable from "../components/ui/AgGridTable";
import { ColDef } from "ag-grid-community";
import { Plus, Edit } from "lucide-react";
import { Button } from "../components/ui/button";

const EmailTemplates = () => {
  const [state] = useState({
    data: [
      {
        id: 1,
        title: "template 1",
        subject: "templates subject",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      },
      {
        id: 2,
        title: "template 2",
        subject: "templates subject",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      },
      {
        id: 3,
        title: "template 3",
        subject: "templates subject",
        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
      },
    ],
  });

  const columnDefs = useMemo<ColDef[]>(() => {
    return [
      {
        headerName: "Sr No.",
        field: "id",
        minWidth: 70,
        width: 80,
      },
      {
        headerName: "Title",
        field: "title",
        minWidth: 140,
        width: 170,
      },
      {
        headerName: "Subject",
        field: "subject",
        minWidth: 160,
        width: 200,
      },
      {
        headerName: "Body",
        field: "body",
        minWidth: 300,
        flex: 2,
        cellRenderer: (p: any) => {
          return (
            <span className="text-slate-600 text-xs truncate" title={p.value}>
              {p.value}
            </span>
          );
        },
      },
      {
        headerName: "Action",
        field: "id",
        minWidth: 90,
        width: 100,
        cellRenderer: () => {
          return (
            <Link
              to="/edit-template"
              className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-semibold bg-slate-50 hover:bg-slate-100 text-slate-700 border border-slate-200 transition-colors"
            >
              <Edit className="w-3.5 h-3.5" />
              <span>Edit</span>
            </Link>
          );
        },
      },
    ];
  }, []);

  return (
    <>
      <div className="flex items-center justify-between gap-3 mb-4">
        <h4 className="text-base font-bold text-slate-800 tracking-tight mb-0">
          Email Templates
        </h4>
        <Link to="/add-template">
          <Button
            variant="default"
            size="sm"
            className="h-9 px-4 text-sm gap-1.5 shadow-xs"
          >
            <Plus className="w-4 h-4" />
            <span>Add Template</span>
          </Button>
        </Link>
      </div>

      <AgGridTable
        rowData={state.data}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        emptyMessage="No email templates found"
      />
    </>
  );
};

export default EmailTemplates;
